import { render, staticRenderFns } from "./CustomizationStep.vue?vue&type=template&id=6974a0fc"
import script from "./CustomizationStep.vue?vue&type=script&lang=ts"
export * from "./CustomizationStep.vue?vue&type=script&lang=ts"
import style0 from "./CustomizationStep.vue?vue&type=style&index=0&id=6974a0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports